export default "__VITE_ASSET__af37e063__"